import { createUseStyles } from 'react-jss';

const useGlobalStyles = createUseStyles((theme) => ({
  '@global': {
    body: {
      backgroundColor: theme.palette.neutralBackground,
      fontFamily: theme.font.family,
      fontSize: theme.font.defaultSize,
      margin: 0,
    },
    button: {
      fontSize: theme.font.defaultSize,
      fontFamily: theme.font.family,
    },
  },
}));

export const useStyles = createUseStyles((theme) => ({
  appLogo: {
    '& path': {
      fill: theme.palette.primaryPure,
    },
  },
  lockIcon: {
    fill: theme.palette.secondaryPure,
    opacity: 0.5,
  },
  backIcon: {
    '& path': {
      fill: 'white',
    },
  },
  externalIcon: {
    '& path': {
      fill: theme.palette.secondaryPure,
      opacity: 0.5,
    },
  },
}));

export default useGlobalStyles;
